import { render, staticRenderFns } from "./costaRica.vue?vue&type=template&id=494c99e8&"
import script from "./costaRica.vue?vue&type=script&lang=js&"
export * from "./costaRica.vue?vue&type=script&lang=js&"
import style0 from "./costaRica.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CountryTop: require('/builds/pagsmile/front-end/pagsmile-web/components/countryGuides/CountryTop.vue').default,CountryDescription: require('/builds/pagsmile/front-end/pagsmile-web/components/countryGuides/CountryDescription.vue').default,CountryFeaturesCostaRica: require('/builds/pagsmile/front-end/pagsmile-web/components/countryGuides/CountryFeaturesCostaRica.vue').default,CountryPaymentCardCostaRica: require('/builds/pagsmile/front-end/pagsmile-web/components/countryGuides/CountryPaymentCardCostaRica.vue').default,FooterTop: require('/builds/pagsmile/front-end/pagsmile-web/components/footer/footerTop.vue').default})
